module.exports = __webpack_public_path__ + "static/media/escudo.23ad0d27.png";